// removed by extract-text-webpack-plugin
module.exports = {"label":"app-pages-Reports-Shift-ShiftDetail-ShiftDetailModal-NameRow-__NameRow___2zwjh","value":"app-pages-Reports-Shift-ShiftDetail-ShiftDetailModal-NameRow-__NameRow___2zR4v"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Reports/Shift/ShiftDetail/ShiftDetailModal/NameRow/NameRow.css
// module id = 2495
// module chunks = 0